<template>
    <div class="card">
        <div class="card-header">
            <h6>Pungutan</h6>

            <button class="btn btn-warning float-end btn-xs" style="margin-right: 5px" @click.prevent="generatePungutan()">
                <i class="link-icon mdi mdi-calculator"></i>
                Generate Pungutan
            </button>
        </div>
        <div class="card-body">
            <vue-good-table title="exim-ceisa-document-list" ref="exim-ceisa-document-list" mode="remote"
                :totalRows="totalRecords" :line-numbers="true" :rows="rows" :columns="columns">

            </vue-good-table>
        </div>
    </div>
</template>

<script>
export default {
    name: "CeisaBarangImporPungutan",
    component: {},
    props: {
        propsData: { type: [Object, Array] }
    },
    data() {
        return {
            rows: [],
            totalRecords: 0,
            columns: [
                {
                    label: "Pungutan",
                    field: "pungutan",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Dibayar",
                    field: "dibayar",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Ditanggung Pemerintah",
                    field: "ditanggung",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Ditunda",
                    field: "ditunda",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Tidak Dipungut",
                    field: "tidakDipungut",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Dibebaskan",
                    field: "dibebaskan",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Sudah Dilunasi",
                    field: "sudahDilunasi",
                    thClass: 'text-center',
                    formatFn: this.toCurrency,
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
            ],
            isLoading: false,
            errors: [],
            forms: [],
        }
    },
    methods: {
        toCurrency(value) {
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'IDR'
            });
            return formatter.format(value);
        },
        generatePungutan() {
            this.rows = [];
            var bm = {
                dibayar: 0,
                ditanggung: 0,
                ditunda: 0,
                tidakDipungut: 0,
                dibebaskan: 0,
                sudahDilunasi: 0,
            };
            var bmt = {
                dibayar: 0,
                ditanggung: 0,
                ditunda: 0,
                tidakDipungut: 0,
                dibebaskan: 0,
                sudahDilunasi: 0,
            };
            var ppn = {
                pungutan: "PPN",
                dibayar: 0,
                ditanggung: 0,
                ditunda: 0,
                tidakDipungut: 0,
                dibebaskan: 0,
                sudahDilunasi: 0,
            };
            var pph = {
                pungutan: "PPH",
                dibayar: 0,
                ditanggung: 0,
                ditunda: 0,
                tidakDipungut: 0,
                dibebaskan: 0,
                sudahDilunasi: 0,
            };
            let barang = this.forms.barang;
            if (barang && barang.length > 0) {
                barang.forEach(el => {
                    var tarifs = el.tarif;
                    if (tarifs && tarifs.length > 0) {
                        tarifs.forEach(tarif => {
                            if (tarif.kodeJenisPungutan == "BM" || tarif.kodeJenisPungutan == "BMKITE") {
                                bm.dibayar += parseFloat(tarif.nilaiBayar);
                                if(tarif.kodeFasilitasTarif == 2){
                                    bm.ditanggung += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 9){
                                    bm.ditunda += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 6){
                                    bm.tidakDipungut += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 5){
                                    bm.dibebaskan += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 7){
                                    bm.sudahDilunasi += parseFloat(tarif.nilaiFasilitas);
                                }
                            }

                            if (tarif.kodeJenisPungutan == "BMAD" || tarif.kodeJenisPungutan == "BMTP" || tarif.kodeJenisPungutan == "BMIM" ) {
                                bmt.dibayar += parseFloat(tarif.nilaiBayar);
                                if(tarif.kodeFasilitasTarif == 2){
                                    bmt.ditanggung += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 9){
                                    bmt.ditunda += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 6){
                                    bmt.tidakDipungut += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 5){
                                    bmt.dibebaskan += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 7){
                                    bmt.sudahDilunasi += parseFloat(tarif.nilaiFasilitas);
                                }
                            }

                            if (tarif.kodeJenisPungutan == "PPN") {
                                ppn.dibayar += parseFloat(tarif.nilaiBayar);
                                if(tarif.kodeFasilitasTarif == 2){
                                    ppn.ditanggung += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 9){
                                    ppn.ditunda += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 6){
                                    ppn.tidakDipungut += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 5){
                                    ppn.dibebaskan += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 7){
                                    ppn.sudahDilunasi += parseFloat(tarif.nilaiFasilitas);
                                }
                            }

                            if (tarif.kodeJenisPungutan == "PPH") {
                                pph.dibayar += parseFloat(tarif.nilaiBayar);
                                if(tarif.kodeFasilitasTarif == 2){
                                    pph.ditanggung += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 9){
                                    pph.ditunda += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 6){
                                    pph.tidakDipungut += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 5){
                                    pph.dibebaskan += parseFloat(tarif.nilaiFasilitas);
                                }else if(tarif.kodeFasilitasTarif == 7){
                                    pph.sudahDilunasi += parseFloat(tarif.nilaiFasilitas);
                                }
                            }


                        });
                    }
                });
            }

            if(bm.dibayar > 0 || bm.ditanggung > 0 || bm.ditunda > 0 || bm.tidakDipungut > 0 || bm.dibebaskan > 0 || bm.sudahDilunasi > 0 ){
                var arrBm = {
                    pungutan:"BM",
                };
                let bmKey = Object.entries(bm);
                bmKey.map( ([key, val] = arrBm) => {
                    var value = Math.ceil(parseFloat(val)/1000)*1000;
                    arrBm[key] = parseFloat(value);
                });
                this.rows.push(arrBm);
            }

            if(bmt.dibayar > 0 || bmt.ditanggung > 0 || bmt.ditunda > 0 || bmt.tidakDipungut > 0 || bmt.dibebaskan > 0 || bmt.sudahDilunasi > 0 ){
                var arrBmt = {
                    pungutan:"BMT",
                };
                let bmtKey = Object.entries(bmt);
                bmtKey.map( ([key, val] = arrBmt) => {
                    var value = Math.ceil(parseFloat(val)/1000)*1000;
                    arrBmt[key] = parseFloat(value);
                });
                this.rows.push(arrBmt);
            }

            console.log(ppn);
            if(ppn.dibayar > 0 || ppn.ditanggung > 0 || ppn.ditunda > 0 || ppn.tidakDipungut > 0 || ppn.dibebaskan > 0 || ppn.sudahDilunasi > 0 ){
                this.rows.push(ppn);
            }

            if(pph.dibayar > 0 || pph.ditanggung > 0 || pph.ditunda > 0 || pph.tidakDipungut > 0 || pph.dibebaskan > 0 || pph.sudahDilunasi > 0 ){
                this.rows.push(pph);
            }

            var arrTotal = {
                pungutan:"Total",
                dibayar: 0,
                ditanggung: 0,
                ditunda: 0,
                tidakDipungut: 0,
                dibebaskan: 0,
                sudahDilunasi: 0,
            };
            this.rows.forEach(el=>{
                console.log(el.pungutan);
                let keys = Object.entries(el);

                keys.map( ([key, val] = arrTotal) => {
                    if(key !== "pungutan"){
                        var value = parseFloat(val);
                        arrTotal[key] += parseFloat(value);
                        console.log(key+" : "+value);
                    }
                });
            });
            
            if(arrTotal.dibayar > 0 || arrTotal.ditanggung > 0 || arrTotal.ditunda > 0 || arrTotal.tidakDipungut > 0 || arrTotal.dibebaskan > 0 || arrTotal.sudahDilunasi > 0 ){
                this.rows.push(arrTotal);
            }
            

        },
        getValueTarif(tarifs, params) {
            var percent = 0;
            if (tarifs && tarifs.length > 0) {
                tarifs.forEach(tarif => {
                    if (tarif.namaJenisPungutan == params) {
                        percent = tarif.tarif;
                    }
                })
            }
            return percent;
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
    created() {
    }

}
</script>

<style lang="scss" scoped></style>